export const DEFAULT_MEDIA_DEFINITIONS = {
    palm: 'screen and (max-width: 44.9375em)',
    lap: 'screen and (min-width: 45em) and (max-width: 63.9375em)',
    lapAndUp: 'screen and (min-width: 45em)',
    portable: 'screen and (max-width: 63.9375em)',
    desk: 'screen and (min-width: 64em)',
    retina: '(-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi)'
};